//@flow

import React, { type Node } from "react";
import { Field, FormSpy } from "react-final-form";
import type { FieldRenderProps } from "react-final-form";

import { OnChange } from "react-final-form-listeners";
import { Input as SharedInput, Button as SharedButton, Dropdown as SharedDropdown } from "shared/formElements";

/* Final Form Utility Fields */

type WhenFieldChangesProps = {
  field: string,
  becomes: any,
  set: string,
  to: any,
  process?: Function,
};

export const WhenFieldChanges = ({ field, becomes, set, to }: WhenFieldChangesProps) => (
  <Field name={set} subscription={{}}>
    {({ input: { onChange } }) => (
      <FormSpy subscription={{}}>
        {({ form }) => (
          <OnChange name={field}>
            {(value) => {
              if (value === becomes) {
                onChange(to);
              }
            }}
          </OnChange>
        )}
      </FormSpy>
    )}
  </Field>
);

export const HiddenInput = ({ name, val }: { name: string, val: string }) => {
  return (
    <Field name={name}>
      {({ input: { onChange, value } }: FieldRenderProps) => {
        return (
          <input
            name={name}
            type="hidden"
            value={val ? setTimeout(() => onChange(val)) : setTimeout(() => onChange(""))}
          />
        );
      }}
    </Field>
  );
};

export const Error = ({ name }: { name: string }) => (
  <Field
    name={name}
    subscribe={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) => (touched && error ? <span>{error}</span> : null)}
  />
);

/* UI components */

export const Row = ({ children, className, field }: { children: Node, className?: String, field?: string }) => (
  <div className={className}>{children}</div>
);
export const Label = ({ children, className }: { children: Node, className: String }) => (
  <p className={className}>{children}</p>
);
export const Input = (props: any) => <SharedInput {...props}>{props.children}</SharedInput>;
export const Dropdown = SharedDropdown;
export const Button = (props: any) => <SharedButton {...props}>{props.children}</SharedButton>;
